<template>
    <div>
        <!-- Spinner removed - pages should use CommonOverlay for loading states -->
        <b-alert 
            :show="this.dismissSuccessCountDown"
            dismissible
            fade
            variant="success"
            @dismissed="setDismissSuccessCountDown(0)"
            @dismiss-count-down="successCountDownChanged"
        >
            {{alertMessage}}
        </b-alert>
        <b-alert 
            :show="this.errored"
            dismissible
            fade
            variant="danger"
            @dismissed="hideIt"
        >
            <!-- ESCAPED ON PURPOSE — do not switch back to v-html.
                 This renders SERVER-controlled error text: extractApiError feeds it from
                 the response body, and main-service returns raw err.message in 9 places,
                 where a driver/SQL exception can carry user-supplied data. Under v-html an
                 injected <img onerror=...> executed here (proven on dev 2026-07-30). The
                 success variant above has always used {{ }}; this now matches it.
                 No caller passes markup — checked across all ~186 alert/setMessage sites. -->
            <span>{{ alertMessage }}</span>
        </b-alert>
    </div>
</template>

<script>

import { mapState, mapActions, mapMutations } from 'vuex';

export default {
  name: 'ErrorDisplay',
  methods: {
    ...mapActions('alert', ['setDismissSuccessCountDown']),
    ...mapMutations('alert', ['setErrored']),

    successCountDownChanged(count) {
        this.setDismissSuccessCountDown(count);
    },

    hideIt() {
        this.setErrored(false);
    }
  },
  computed: {
    ...mapState({
        errored: state => state.alert.errored,
        alertMessage: state => state.alert.message,
        dismissSuccessCountDown : state => state.alert.dismissSuccessCountDown,
    }),
  }
}
</script>

<style lang="scss">

</style>